
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

@Component({
  components: {
    ValidationProvider,
  },
})
export default class CountryDropdown extends Vue {
  @Prop()
  countryList?: Array<any>;

  @Prop()
  userCountry?: string;
}
